export default __webpack_public_path__ + "static/media/eym_zh.240777b7.svg";